import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

/**
 * Controles anti-fraude OCR en comprobaciones de detalle de operación.
 */
@Component({
	selector: 'app-operation-ocr-checks-antifraud',
	imports: [ChecksComponent],
	templateUrl: './operation-ocr-checks-antifraud.component.html',
	styleUrl: './operation-ocr-checks-antifraud.component.scss',
})
export class OperationOcrChecksAntifraudComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;
	@Input({ required: true }) checks!: (CHECK | undefined)[];
}
